var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Numero do Cartão","placeholder":"Num Cartão","hide-details":""},on:{"change":_vm.onChange},model:{value:(_vm.NumeroCartao),callback:function ($$v) {_vm.NumeroCartao=$$v},expression:"NumeroCartao"}})}
var staticRenderFns = []

export { render, staticRenderFns }